import VueRouter from "vue-router";

Vue.use(VueRouter)

import router from '../route/converter';

const landingConverter = new Vue({
    el        : '#landing-converter',
    components: {},
    router
});
